// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noSemantic--V8LC5 label {
  font: unset;
  text-rendering: geometricPrecision;
  font-family: var(--font-family-default);
  line-height: var(--font-lineHeight-default);
  color: var(--font-color-primary);
}
`, "",{"version":3,"sources":["webpack://./src/institution_settings/JsonInput.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kCAAkC;EAClC,uCAAuC;EACvC,2CAA2C;EAC3C,gCAAgC;AAClC","sourcesContent":[".noSemantic label {\n  font: unset;\n  text-rendering: geometricPrecision;\n  font-family: var(--font-family-default);\n  line-height: var(--font-lineHeight-default);\n  color: var(--font-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noSemantic": `noSemantic--V8LC5`
};
export default ___CSS_LOADER_EXPORT___;
